import type { ReactNode } from 'react';
import { Box, Flex, Heading, Icon, Paragraph, Text } from '@customerio/pluma-components/react';
import type { IconProps } from '@customerio/pluma-components/react';
import * as styles from './signup-startup-marketing.css';

type SellingPointProps = {
  icon: IconProps['name'];
  children: ReactNode;
};

function SellingPoint({ icon, children }: SellingPointProps) {
  return (
    <Flex alignItems="flex-start" gap="200">
      <Box className={styles.iconBadge}>
        <Icon name={icon} sizeVersion="v2" size="md" color="inherit" />
      </Box>
      <Text text="product-h2" weight="regular">
        {children}
      </Text>
    </Flex>
  );
}

/** The startup application's left-hand pitch column. */
export function SignupStartupMarketing() {
  return (
    <Box>
      <Text size="m" color="subtle" weight="medium" display="block" mb="100">
        Startup Program Application
      </Text>
      <Heading level="1" size="xxxl" mb="300" className={styles.heading}>
        Thank you for your interest!
      </Heading>
      <Paragraph size="l" mb="200">
        We're passionate about supporting startups because not too long ago, we were one.
      </Paragraph>
      <Paragraph size="l" mb="500">
        *Now accepting startups with up to $10 million in funding.
      </Paragraph>

      <Flex direction="column" gap="300" mb="500">
        <SellingPoint icon="feature-launch">
          Grow using Customer.io as an integral part of your business and messaging strategy.
        </SellingPoint>
        <SellingPoint icon="cursor">Your startup business gets access to a best-in-class messaging tool.</SellingPoint>
        <SellingPoint icon="segment-data-driven">
          Harnesses real-time behavioral data and advanced segmentation with our platform.
        </SellingPoint>
      </Flex>

      <Paragraph variant="secondary" size="s">
        *If your startup has over $10M in funding, we still want to hear from you! We love startups and will gladly find
        the best plan for you.
      </Paragraph>
    </Box>
  );
}
